import axios from '../helpers/axios'
import { logError } from '../services';
import {
  IAuthoritiesResponse,
  IAuthorityDetail,
  IAuthorityDetailCreate,
  IAuthorityDetailUpdate,
  IAuthorityType
} from '../models';

export const getAuthorities = async (filters?: {
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
  isActive?: boolean;
}): Promise<IAuthoritiesResponse> => {
  try {
    const { data } = await axios.get(`/api/authorities`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getAuthorities failed');
    return Promise.reject(error);
  }
};

export const createAuthority = async (post: IAuthorityDetailCreate): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/authorities`, post);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: post
      },
      'createAuthority failed'
    );
    return Promise.reject(error?.response?.data);
  }
};

export const getAuthority = async (id): Promise<IAuthorityDetail> => {
  try {
    const { data } = await axios.get(`/api/authorities/${id}`);
    return data;
  } catch (error) {
    logError(error, 'getAuthority failed');
    return Promise.reject(error);
  }
};

export const updateAuthority = async (id, put: IAuthorityDetailUpdate): Promise<any> => {
  try {
    const { data } = await axios.put(`/api/authorities/${id}`, put);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: put
      },
      'updateAuthority failed'
    );
    return Promise.reject(error?.response?.data);
  }
};

export const getAuthorityTypes = async (): Promise<IAuthorityType[]> => {
  try {
    const { data } = await axios.get('/api/authorities/types');
    return data;
  } catch (error) {
    logError(error, 'getAuthorityTypes failed');
    return Promise.reject(error);
  }
};
